/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Stillactive_Title2Inputs */

const en_coinvestments_report_stillactive_title2 = /** @type {(inputs: Coinvestments_Report_Stillactive_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This deal is still active`)
};

/**
* | output |
* | --- |
* | "This deal is still active" |
*
* @param {Coinvestments_Report_Stillactive_Title2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_stillactive_title2 = /** @type {((inputs?: Coinvestments_Report_Stillactive_Title2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Stillactive_Title2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_stillactive_title2(inputs)
});
export { coinvestments_report_stillactive_title2 as "coInvestments_report_stillActive_title" }